import React from "react";
import {Portal} from "@mui/material";
import {CONTROLS_PORTAL_ID} from "./BasePage.tsx";

interface ControlsSectionProps {
    children: React.ReactNode;
}

export const ControlsSection = (props: ControlsSectionProps) => {
    return (
        <Portal container={() => document.getElementById(CONTROLS_PORTAL_ID)}>
            {props.children}
        </Portal>
    );
};
